import React, { useState, useEffect } from 'react';
import {HIDE, MIXES, SUBSEQUENCE} from 'components/mix/constants.js';
import {setMixViewMode} from 'actions/index.js';
import { connect } from "react-redux";

class MixTab extends React.Component {
    onClick(type, subSequence) {
        this.props.setMixViewMode(type);

        if (subSequence !== undefined) {
            this.props.sequencerEngine.switchToSubSequence(subSequence);
        }
    }

    render() {
        let subSequences = this.props.sequencerEngine.subSequences.map(x => x.id);
        return (
            <div className="mix-tab">
              {subSequences.map(
                  id => 
                      <MixTabOption
                        key={id}
                        onClick={() => this.onClick(SUBSEQUENCE, id)}
                        isCurrent={this.props.currentSubSequence === id}
                        selected={this.props.mixViewMode === SUBSEQUENCE && this.props.currentSubSequence === id}
                        name={this.props.sequencerEngine.getSubSequenceName(id)}/>)}
                <MixTabOption
                  onClick={() => this.onClick(MIXES)}
                  selected={this.props.mixViewMode === MIXES} name="ALL"/>
            </div>
        );
    }
}

function MixTabOption(props) {
    let className = "mix-tab-option";
    if (props.selected) {
        className += ' selected';
    }
    if (props.isCurrent) {
        className += ' current';
    }
    return (
        <div onClick={props.onClick} className={className}>{props.name}</div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
        mixViewMode: state.mix.mixViewMode,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setMixViewMode: mixViewMode => dispatch(setMixViewMode(mixViewMode)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MixTab);
